import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CdkDrag, CdkDragStart } from '@angular/cdk/drag-drop';
import { MapMngr, getNewmiLoadingConfig } from '../asp/MapMngr';
import * as settings from '../common/settings';
import * as utils from '../common/utils';
import { ZIndexMngr } from '../common/ZIndexMngr';
import { AppConfig } from '../app.config';
import { SecondScreenComponent } from '@core_n/second-screen/second-screen.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-sub-area',
  templateUrl: './sub-area.component.html',
  styleUrls: ['./sub-area.component.scss'],
})
export class SubAreaComponent extends ZIndexMngr implements OnInit {

  static readonly MAX_SUB_AREA_NUM = 3;
  static readonly MAX_3D_AREA_NUM = 1;

  newmiLoadingConfig: any;

  @ViewChild('mapSubArea', { read: ElementRef, static: true }) private mapSubArea: ElementRef;
  @ViewChild('newmiMap', { read: ElementRef, static: true }) private newmiMap: ElementRef;

  myIndex: number = 0;
  myLabel: string;

  private dialogContainer: HTMLElement;
  private subMapMngr: MapMngr;
  private extent: settings.MapExtent;
  private latestWidth = 0;
  private latestHeight = 0;
  private requestedWidth;
  private requestedHeight;
  private cdkDrag: CdkDrag = null;
  private map: any;
  private is3D: boolean;
  private title: string;
  private info: string;
  private previousLang: string;

  private static indexSet: Set<number> = new Set();
  private static indexSet3D: Set<number> = new Set();

  constructor(public dialogRef: MatDialogRef<SubAreaComponent>,
    elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any,
    private translateService: TranslateService) {
    super(elementRef);
    this.is3D = data.is3D;
    this.newmiLoadingConfig = getNewmiLoadingConfig(data.is3D);
    let _this = this;
    setInterval(function () { _this.periodic() }, 200);
  }

  static createDialogConfig(minSize: number, is3D: boolean) {
    const dialogConfig = utils.createDialogConfig(true, false, undefined, { left: '5000px', top: '5000px' } /* off screen  */);
    dialogConfig.minWidth = `${minSize}px`;
    dialogConfig.minHeight = `${minSize}px`;
    dialogConfig.maxWidth = `1200px`;
    dialogConfig.maxHeight = `800px`;
    dialogConfig.disableClose = true;
    dialogConfig.restoreFocus = false;
    dialogConfig.data = { is3D: is3D };
    return dialogConfig;
  }

  getMapMngr(): MapMngr {
    return this.subMapMngr;
  }

  ngOnInit() {
    this.dialogContainer = this.mapSubArea.nativeElement.parentElement.parentElement;
    this.latestHeight = this.dialogContainer.clientHeight;
    this.latestWidth = this.dialogContainer.clientWidth;

    // SecondScreenComponent._secondScreen.document.getElementsByClassName('second-screen').item(0).appendChild(this.dialogContainer.parentElement.parentElement);
    if (this.translateService.currentLang != this.previousLang) {
      this.translateService.get('MAP').subscribe((translated: string) => {
        this.title = translated['SECONDARY_MAP'];
        this.info = translated['SUB_AREA'];
      });
      this.previousLang = this.translateService.currentLang;
    }

    this.myIndex = SubAreaComponent.getFreeIndex(this.is3D);
    if (this.is3D)
      this.myLabel = SubAreaComponent.MAX_3D_AREA_NUM < 2 ? `3D View` : `3D View ${this.myIndex}`;
    else
      this.myLabel = `${this.title} ${this.myIndex}`;

    this.createMap();
  }

  private createMap() {
    if (this.is3D) {
      this.map = NeWMI.Create.map(this.newmiLoadingConfig.engine, this.newmiMap.nativeElement,
        {
          viewType: NeWMI.Map.Enums.EViewType.Globe,
          baseLayer: NeWMI.Create.arcgisTiledLayer(
            this.newmiLoadingConfig.engine,
            { url: AppConfig.settings.map.globe.url }
          )
        });
      this.finishedLoading();
    }
    else {
      this.map = NeWMI.Create.map(this.newmiLoadingConfig.engine, this.newmiMap.nativeElement,
        {
          mapReadyCallback: () => { this.finishedLoading() }
        });
      if (AppConfig.settings.map.esri) {
        let _this = this;
        setTimeout(function () { _this.tinyResize() }, 300);
      }
    }
  }

  private tinyResize() {
    if (this.dialogContainer) {
      this.dialogContainer.style.height = `${Math.round(this.requestedHeight + 1)}px`;
      this.dialogContainer.style.width = `${Math.round(this.requestedWidth)}px`;
    }
  }

  private finishedLoading() {
    this.subMapMngr = new MapMngr(false, this.is3D);
    this.tinyResize();

    let _this = this;
    setTimeout(function () { _this.afterMapLoaded() }, this.is3D ? 2000 : 200);
  }

  isShown(): boolean {
    return this.dialogContainer && this.subMapMngr && this.subMapMngr.shown();
  }

  show(extent: settings.MapExtent, width?: number, height?: number, internal?: boolean) {
    if (width && height) {
      this.requestedWidth = Math.round(width);
      this.requestedHeight = Math.round(height);
      if (this.dialogContainer) {
        this.dialogContainer.style.height = `${this.requestedHeight}px`;
        this.dialogContainer.style.width = `${this.requestedWidth}px`;
      }
    }

    this.extent = extent.clone();

    if (this.subMapMngr) {
      this.subMapMngr.setShown(true);
      this.subMapMngr.setMapExtent(extent);
      this.subMapMngr.getMap().layoutChanged();
      if (!internal) {
        this.subMapMngr.refresh(); // this will properly set the display settings before objects are created
        this.subMapMngr.createObjects();
        this.subMapMngr.subscribeObjects();
      }
    }

    // if (this.myIndex == 0) {
    //   this.myIndex = SubAreaComponent.getFreeIndex(this.is3D);
    //   if (this.is3D)
    //     this.myLabel = SubAreaComponent.MAX_3D_AREA_NUM < 2 ? `3D View` : `3D View ${this.myIndex}`;
    //   else
    //     this.myLabel = `${this.title} ${this.myIndex}`;
    // }

    if (this.dialogContainer) {
      this.dialogRaise();
      let mainElem = document.firstElementChild;
      this.dialogRef.updatePosition({ top: `${mainElem.clientHeight - this.requestedHeight - 50}px`, left: `20px` });
    }
  }

  hide() {
    if (this.cdkDrag)
      this.cdkDrag.reset();
    if (this.subMapMngr && this.subMapMngr.shown()) {
      this.dialogRef.updatePosition({ top: `5000px`, left: `20px` }); // move out of sight
      this.subMapMngr.setShown(false);
      this.subMapMngr.unsubscribeObjects();
      this.subMapMngr.clearObjects();
    }
    this.dialogClosed();
    SubAreaComponent.clearIndex(this.myIndex, this.is3D);
    this.myIndex = 0;
  }

  private afterMapLoaded() {
    this.subMapMngr.initMap(this.map);
    this.show(this.extent, undefined, undefined, true /* internal */);
    this.show(this.extent, undefined, undefined, true /* internal */); // this makes sure map shows correct extent...

    let _this = this;
    setTimeout(function () { _this.afterAfterMapLoaded() }, this.is3D ? 2000 : 400);
  }

  private afterAfterMapLoaded() {
    this.subMapMngr.refresh(); // this will properly set the display settings before objects are created
    this.subMapMngr.createObjects();
    this.subMapMngr.subscribeObjects();
  }

  onDragStart(evt: CdkDragStart) {
    this.cdkDrag = evt.source;
  }

  private periodic() {
    if (this.translateService.currentLang != this.previousLang) {
      this.translateService.get('MAP').subscribe((translated: string) => {
        this.title = translated['SECONDARY_MAP'];
        this.info = translated['SUB_AREA'];
      });
      this.previousLang = this.translateService.currentLang;
      if (this.is3D)
        this.myLabel = SubAreaComponent.MAX_3D_AREA_NUM < 2 ? `3D View` : `3D View ${this.myIndex}`;
      else
        this.myLabel = `${this.title} ${this.myIndex}`;
    }
    if (AppConfig.settings.map.esri)
      return;
    if (!this.subMapMngr || !this.subMapMngr.shown())
      return;

    let w = this.dialogContainer.clientWidth;
    let h = this.dialogContainer.clientHeight;

    if (w != this.latestWidth || h != this.latestHeight) {
      this.subMapMngr.getMap().layoutChanged();
      this.latestWidth = w;
      this.latestHeight = h;
    }
  }

  // Clear given index
  private static clearIndex(index: number, is3D: boolean) {
    if (is3D)
      SubAreaComponent.indexSet3D.delete(index);
    else
      SubAreaComponent.indexSet.delete(index);
  }

  // Get free index, and occupy it
  private static getFreeIndex(is3D: boolean): number {
    let index = 1;
    if (is3D) {
      while (SubAreaComponent.indexSet3D.has(index))
        index++;
      SubAreaComponent.indexSet3D.add(index);
    }
    else {
      while (SubAreaComponent.indexSet.has(index))
        index++;
      SubAreaComponent.indexSet.add(index);
    }
    return index;
  }
}
